<template>
  <div>
    <!-- Total solicitudes registradas -->
    <TotalComplaints
      :styleWidth="'w-80'"
      :total="count"
      title="Total de quejas"
      body="quejas registradas"
    />

    <!-- Filtro de busqueda de solicitudes -->
    <ManagementFilter
      :loading="loading"
      :searching="searching"
      @getFilterForm="setFilterForm"
    />
    <div
      class="bg-white overflow-x-auto rounded-xl border border-gray-300 mx-4 mt-4 search-complaints"
    >
      <div class="p-4 flex justify-start mt-4">
        <a-menu mode="horizontal">
          <a-sub-menu>
            <a-button
              slot="title"
              type="primary"
              style="margin-bottom: 16px"
              v-on:click="collapsed = !collapsed"
            >
              <a-icon :type="collapsed ? 'menu-unfold' : 'menu-fold'" />
            </a-button>
            <a-menu-item
              v-if="collapsed"
              @click="() => generateInfoSolip('xlsx')"
            >
              <span class="mx-2">
                <a-icon
                  type="download"
                  :style="{ fontSize: '16px' }"
                  class="mr-2"
                />
                .XLSX</span
              >
            </a-menu-item>
            <a-menu-item
              v-if="collapsed"
              @click="() => generateInfoSolip('csv')"
            >
              <span class="mx-2">
                <a-icon
                  type="download"
                  :style="{ fontSize: '16px' }"
                  class="mr-2"
                />
                .CSV (Separado por comas)</span
              >
            </a-menu-item>
            <a-menu-item
              v-if="collapsed"
              @click="() => generateInfoSolip('txt')"
            >
              <span class="mx-2">
                <a-icon
                  type="download"
                  :style="{ fontSize: '16px' }"
                  class="mr-2"
                />.txt</span
              >
            </a-menu-item>
          </a-sub-menu>
        </a-menu>
      </div>

      <!-- Tabla de datos de solicitudes -->
      <ManagementTable
        :dataSource="complaintsEmisores"
        @retryRadicadoSolip="retryRadicadoSolip"
      />

      <div class="p-4 flex justify-end">
        <a-pagination
          v-model="page"
          :page-size="pageSize"
          :page-size-options="pageSizeOptions"
          :total="count"
          show-size-changer
          size="large"
          @showSizeChange="onShowSizeChange"
          @change="onChange"
        />
      </div>
    </div>
    <Modal v-if="viewModal" size="md">
      <div class="text-center">
        <p class="mt-4">{{ msgToModal }}</p>
        <button
          @click="closeModal"
          class="mt-4 py-2 px-4 bg-blue-500 text-white rounded-lg"
        >
          ACEPTAR
        </button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ManagementFilter from "../partials/ManagementFilter.vue";
import ManagementTable from "../partials/ManagementTable.vue";
import TotalComplaints from "@/components/Dashboard/Complaints/TotalComplaints.vue";
import complaintsEmisorServicesImplementation from "@/feature/dashboard/complaints_emisor/data/services/complaints_emisor_services_impl";
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from "@/core/utils/constants";
import ErrorMessaje from "@/core/error/error_messaje";

export default {
  components: {
    TotalComplaints,
    ManagementFilter,
    ManagementTable,
  },
  data() {
    return {
      collapsed: false,
      count: 0,
      loading: false,
      form: {},
      page: DEFAULT_PAGE,
      pageSize: DEFAULT_PAGE_SIZE,
      pageSizeOptions: ["50", "100", "150", "200", "250"],
      searching: false,
      complaintsEmisores: [],
      msgToModal: "",
      viewModal: false,
    };
  },
  methods: {
    async setFilterForm(form, pagination) {
      this.form = form;
      if (pagination.page && pagination.pageSize) {
        this.page = pagination.page;
        this.pageSize = pagination.pageSize;
      }
      await this.fetchData();
    },

    async fetchData() {
      this.loading = true;
      this.searching = true;
      const pagination = {
        page: this.page,
        pageSize: this.pageSize,
      };
      try {
        const response =
          await complaintsEmisorServicesImplementation.getComplaintEmisoresList(
            pagination,
            this.form
          );

        if (response.isSuccess) {
          this.setDeafultEmited(response.data);
          return;
        } else {
          this.showToast("error", response.message);
          this.setDeafultEmited(null);
          return;
        }
      } catch (error) {
        this.showToast("error", ErrorMessaje.internalServerError);
        this.setDeafultEmited(null);
      } finally {
        this.loading = false;
        this.searching = false;
      }
    },
    async generateInfoSolip(typeExport) {
      this.loading = true;
      this.searching = true;

      try {
        const response =
          await complaintsEmisorServicesImplementation.generateComplaintEmisoresInfoSolip(
            typeExport,
            this.form
          );

        if (response.isSuccess) {
          const link = document.createElement("a");
          link.href = response.data.url;
          link.setAttribute("download", "solip_file");
          document.body.appendChild(link);
          link.click();
        } else {
          this.showToast("error", ErrorMessaje.generalError);
        }
      } catch (error) {
        this.showToast("error", ErrorMessaje.internalServerError);
      } finally {
        this.loading = false;
        this.searching = false;
        return;
      }
    },
    setDeafultEmited(resp) {
      this.count = resp?.count || 0;
      const data = resp?.results || [];

      if (data.length > 0) {
        this.complaintsEmisores = data.map((element) => {
          // The 'T' is replaced by a space for better readability in the table.
          const formattedDate = element.fecha_creacion.replace("T", " ");
          return {
            ...element,
            fecha_creacion: formattedDate,
          };
        });
      } else {
        this.complaintsEmisores = [];
      }
    },
    async retryRadicadoSolip(codigoQueja) {
      this.loading = true;
      this.searching = true;

      const data = {
        codigo_queja: codigoQueja,
      };

      try {
        const response =
          await complaintsEmisorServicesImplementation.retryFilingSolip(
            codigoQueja,
            data
          );

        if (response.isSuccess) {
          this.msgToModal =
            "Proceso de reintento de radicación completado con éxito.";
          if (response.data && response.data.details) {
            this.msgToModal = response.data.details;
          }
          this.viewModal = true;
          return;
        } else {
          let errorMessage = ErrorMessaje.generalError;
          if (response.data && response.data.error) {
            errorMessage = response.data.error;

            if (response.data && response.data.detail) {
              errorMessage = errorMessage + " - " + response.data.detail;
            }
          }
          this.showToast("error", errorMessage);
          return;
        }
      } catch (error) {
        this.showToast("error", ErrorMessaje.internalServerError);
      } finally {
        this.loading = false;
        this.searching = false;
      }
    },
    closeModal() {
      this.viewModal = false;
      this.fetchData();
    },
    // Cambio de tamaño de página
    onShowSizeChange(page, page_size) {
      // Ante el cambio en el tamaño de la pagina se debe reiniciar la página a 1
      this.page = 1;
      this.pageSize = page_size;
      this.fetchData();
    },
    // Cambio de página
    onChange(page, page_size) {
      this.page = page;
      this.pageSize = page_size;
      this.fetchData();
    },
    showToast(result = "info", msg) {
      this.$notification[result]({
        message: "Resultado",
        description: msg,
        onClick: () => {},
      });
    },
  },
};
</script>

<style></style>
